// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles__footer___2Z5_D","done":"styles__done___3qj20"};